import { useQueryClient } from '@tanstack/vue-query'
import { inject, onBeforeMount, unref } from 'vue'
import { wsClient } from '#shared/api/ws-client'
import { guest } from '#shared/lib/user/guest'
import { userInjectionKey } from '#shared/lib/user/user-injection-key'
import type { User } from '#shared/model/user'
import type { UserEvent } from '#shared/model/user-event'
import { CURRENT_USER_QUERY_KEY } from './current-user-query'

export function useDynamicUserUpdates() {
  const queryClient = useQueryClient()

  const currentUser = inject(userInjectionKey)

  const updateUser = (user: User) => {
    const currentUserVal = unref(currentUser)
    if (currentUserVal === guest) return
    if (user.id !== currentUserVal?.id) return

    queryClient.setQueryData(CURRENT_USER_QUERY_KEY, (fetchedUser: User | typeof guest | undefined) => {
      if (!fetchedUser) return
      if (fetchedUser === guest) return guest
      return { ...fetchedUser, ...user }
    })
  }

  const onUserEvent = (event: UserEvent) => {
    if (event.operation === 'update') {
      updateUser(event.user)
    }
  }

  onBeforeMount(() => {
    wsClient.on('user', onUserEvent)
  })
}
